import React from "react";
import "./Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import profilePic1 from "../../img/profile1.jpg";
import profilePic2 from "../../img/profile2.jpg";
import profilePic3 from "../../img/profile3.jpg";
import profilePic4 from "../../img/profile4.jpg";
import { Pagination } from "swiper";
import "swiper/css/pagination";
import "swiper/css";
const Testimonial = () => {
  const clients = [
    {
      img: profilePic1,
      review:
        "Arif is an extraordinary guy. He can convert your any app idea to real world application. I would highly recommend him for your future project.",
    },
    {
      img: profilePic2,
      review:
        "Arif's Work is very clean, He follows the design exactly that was made. He handles the time very well. Detailed documentation was asked. Clean code and good practices. Work with Arif it's amazing and a pleasure. Always recommended.",
    },
    {
      img: profilePic3,
      review:
        "Arif is a great coder. He understands quickly the UI/UX of the project. When I issue happens He always comes back with a solution or a contribution. It was a pleasure to work with him because he's proactive and it's open to finding solutions. Highly recommended.",
    },
    {
      img: profilePic4,
      review:
        "Arif is one of the best freelancers here in Upwork, I had an excellent experience working with him. He provided me with all the service as I expected from him. He has all the technical skills required to get the work done. I enjoyed working with him and I would like to work with him in another work in the future, Highly recommended.",
    },
  ];
  return (
    <div className="t-wrapper" id="testimonials" data-aos="fade-up">
      <div className="t-heading">
        <span>Clients always get </span>
        <span>Exceptional work </span>
        <span>from me...</span>
        <div
          className="blur t-blur1"
          style={{ background: "var(--purple)" }}
        ></div>
        <div className="blur t-blur2" style={{ background: "skyblue" }}></div>
        {/* slider */}
      </div>
      <Swiper
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {clients.map((client, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="testimonial">
                <img src={client.img} alt="" />
                <span>{client.review}</span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Testimonial;
